import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import Lessons from "./pages/Lessons";
import LearningPaths from "./pages/LearningPaths";
import Topics from "./pages/Topics";
import FeaturedLessons from "./pages/FeaturedLessons";
import Dashboard from "./pages/Dashboard";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/learning-paths" element={<LearningPaths />} />
        <Route path="/topics" element={<Topics />} />
        <Route path="/featured-lessons" element={<FeaturedLessons />} />
        <Route path="/lessons/:courseId" element={<Lessons />} />
        <Route path="/lessons/:courseId/:lessonId" element={<Lessons />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;